import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";

import useGetAvailableCountries from "../../../hooks/useGetAvailableCountries";
import MultiSelectDropdown from "./base/MultiSelectDropdown";

const SelectAvailableCountries = ({ selectedCountries, setSelectedCountries }) => {
  const { availableCountries = [] } = useGetAvailableCountries();

  const values = useMemo(() => {
    return (availableCountries || []).map((c) => ({
      value: c,
      label: (
        <FormattedMessage
          id={`app.taxResidence.${c}`}
          defaultMessage={c}
        />
      ),
    }));
  }, [availableCountries]);

  return (
    <MultiSelectDropdown
      title="app.report.country"
      values={values}
      value={selectedCountries}
      onChange={setSelectedCountries}
      defaultSelected={selectedCountries}
      enableIntlOption={false}
      emptyMessage="app.countries.empty"
    />
  );
};

export default React.memo(SelectAvailableCountries);
